import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import SecureStorage from "react-secure-storage";

import Login from "./page/Login/Login";
import Home from "./page/Home/Home";
import Main from "./page/Main/Main";
import ResultPage from "./page/ResultPage/ResultPage";
import ScrollDemo from "./page/ScrollDemo/ScrollDemo";
import ProtectedRoute from "./components/ProtectedRoute";
import BeforeUnloadWarning from "./components/BeforeUnloadWarning/BeforeUnloadWarning";

const BroadcastChannelListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    //auth-channel 채널
    const channel = new BroadcastChannel("auth-channel");
    channel.onmessage = (event) => {
      if (event.data.type === "LOGOUT") {
        SecureStorage.clear();
        navigate("/login", { replace: true });
      } else if (event.data.type === "LOGIN") {
        SecureStorage.setItem("isLoggedIn", "true");
        SecureStorage.setItem("email", event.data.email);
        SecureStorage.setItem("doctorId", event.data.doctorId);
        SecureStorage.setItem("userName", event.data.userName);

        navigate("/home", { replace: true });
      }
    };

    return () => {
      channel.close();
    };
  }, [navigate]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <BroadcastChannelListener />
        <BeforeUnloadWarning />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/main"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />
          <Route
            path="/result/:id"
            element={
              <ProtectedRoute>
                <ResultPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
